/**
 * Format a number as currency
 * @param {number} value - The number to format
 * @returns {string} Formatted currency string
 */
export const formatCurrency = (value) => {
  return new Intl.NumberFormat('en-US', {
    style: 'currency',
    currency: 'EUR',
    minimumFractionDigits: 0,
    maximumFractionDigits: 0,
  }).format(value);
};

/**
 * Format a number as a percentage
 * @param {number} value - The number to format
 * @returns {string} Formatted percentage string
 */
export const formatPercent = (value) => {
  return new Intl.NumberFormat('en-US', {
    style: 'percent',
    minimumFractionDigits: 1,
    maximumFractionDigits: 1,
  }).format(value / 100); // Convert from decimal to percentage
};

/**
 * Format a number as months
 * @param {number} value - The number of months
 * @returns {string} Formatted months string
 */
export const formatMonths = (value) => {
  const years = Math.floor(value / 12);
  const months = Math.round(value % 12);
  
  if (years === 0) {
    return `${months} months`;
  } else if (months === 0) {
    return `${years} year${years !== 1 ? 's' : ''}`;
  } else {
    return `${years} year${years !== 1 ? 's' : ''} ${months} months`;
  }
}; 